import { propertyGroupQueryKeys as e } from "./propertyGroupQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { propertyGroupsApi as r } from "@maat/api-main";
//#region src/propertyGroups/useDeletePropertyGroupMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: (e) => r.deleteGroup(e),
		onSuccess: (t, n) => {
			i.invalidateQueries({ queryKey: e.list() }), i.removeQueries({ queryKey: e.detail(n) });
		}
	});
};
//#endregion
export { i as useDeletePropertyGroupMutation };
